<template>
  <div class="boxDayPicker">
    <v-row
      v-for="(schedule, index) in schedules"
      :key="index"
      class="mb-1"
    >
      <!-- Day of the week select -->
      <v-col
        cols="12"
        sm="12"
        md="3"
      >
        <v-select
          v-model="schedule.day"
          :items="days"
          :label="$t('forms.labels.day') + (schedule.day ? ` (${days.find(day => day.key === schedule.day).name})` : '')"
          itemText="name"
          itemValue="key"
          outlined
          data-cy="dayOfWeek"
          @input="() => onSelectDay(index, schedule.day)"
        />
      </v-col>
      <!-- Time select -->
      <v-col
        cols="12"
        sm="12"
        md="6"
        class="timeSelect"
      >
        <v-text-field
          v-model="schedule.time"
          :label="getStartTimeLabelText()"
          outlined
          data-cy="timeSelect"
          readonly
          @focus="showTimePicker(index)"
        />
        <template v-if="schedule.showTime">
          <v-time-picker
            v-if="schedule.showTime"
            v-model="schedule.time"
            width="250"
            noTitle
            :format="timePickerFormat[$store.getters.lang]"
            :locale="locale"
            outlined
            @input="onSelectTime(index, schedule.time)"
          />
          {{ showTimePicker[index] }}
          <v-spacer />
          <div class="d-flex justify-space-between">
            <v-btn
              text
              color="primary"
              @click="onClickCancel(index)"
            >
              {{ $t('forms.btn.cancel') }}
            </v-btn>
            <v-btn
              text
              :disabled="!schedules[index].time"
              color="primary"
              @click="onClickConfirm(index)"
            >
              {{ $t('forms.btn.confirm') }}
            </v-btn>
          </div>
        </template>
      </v-col>
      <!-- Duration in minutes -->
      <v-col
        cols="9"
        sm="9"
        md="2"
      >
        <v-text-field
          v-model="schedule.duration"
          :label="getDurationLabelText()"
          outlined
          data-cy="duration"
          @input="() => onDurationChange(index, schedule.duration)"
        />
      </v-col>
      <!-- Remove button for each schedule -->
      <v-col class="box-close">
        <v-btn
          icon
          color="grey"
          class="buttonClose"
          @click="removeSchedule(index)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- Plus button to add new schedule -->
    <v-row>
      <v-col>
        <v-btn
          icon
          class="secondary"
          dark
          @click="addScheduledInjection"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="bold-text text-left">
          {{ $t('treatmentPrograms.injectionAdd') }}
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _timePickerFormat from '@/constants/timePickerFormat';

export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        locale: {
            type: String,
            default: 'en-US',
        },
    },
    data() {
        return {
            schedules: [
                { day: null, time: null, duration: null, showTime: false },
            ],

            days: [
                { key: 'monday', name: this.$t('daysOfWeek.monday') },
                { key: 'tuesday', name: this.$t('daysOfWeek.tuesday') },
                { key: 'wednesday', name: this.$t('daysOfWeek.wednesday') },
                { key: 'thursday', name: this.$t('daysOfWeek.thursday') },
                { key: 'friday', name: this.$t('daysOfWeek.friday') },
                { key: 'saturday', name: this.$t('daysOfWeek.saturday') },
                { key: 'sunday', name: this.$t('daysOfWeek.sunday') },
            ],
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
        ]),
        timePickerFormat() {
            return _timePickerFormat;
        },
    },

    created() {
        this.fetchStoredSchedules();
    },
    methods: {
        onClickCancel(index) {
            this.schedules[index].showTime = false;
        },
        onClickConfirm(index) {
            this.schedules[index].showTime = false;
        },
        fetchStoredSchedules() {
            this.schedules = this.value;
        },
        addScheduledInjection() {
            // Create an empty schedule entry
            const newSchedule = {
                day: null,
                time: null,
                duration: null,
                showTime: false,
            };
            this.schedules.push(newSchedule);
        },
        getStartTimeLabelText() {
            const startTimeText = this.$t('treatmentPrograms.startTime');
            const appendedText = `${startTimeText} (HH:MM)`;
            return appendedText;
        },
        getDurationLabelText() {
            const startTimeText = this.$t('treatmentPrograms.duration');
            const appendedText = `${startTimeText} (min)`;
            return appendedText;
        },
        removeSchedule(index) {
            this.schedules.splice(index, 1);
            this.$emit('input', this.schedules);
        },
        onSelectDay(index, selectedDay) {
            this.$set(this.schedules[index], 'day', selectedDay);
            this.$emit('input', this.schedules);
        },
        onSelectTime(index, selectedTime) {
            this.$set(this.schedules[index], 'time', selectedTime);
            this.$emit('input', this.schedules);
        },
        onDurationChange(index, duration) {
            this.$set(this.schedules[index], 'duration', duration);
            this.$emit('input', this.schedules);
        },
        showTimePicker(index) {
            this.$set(this.schedules[index], 'showTime', true);
        },
    },
};
</script>
<style lang="scss">
.bold-text {
    font-weight: bold;
}

.boxDayPicker {

    .buttonClose {
        position: absolute;
        display: flex;
        align-content: center;
    }

    .timeSelect {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .box-close {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 10px;
    }
}
</style>
